<div class="feature-flags-admin" [ngClass]="config?.theme || 'default'">
  <header class="admin-header">
    <h1>Feature Flags Administration</h1>
    <div class="actions">
      <button mat-button color="primary" *ngIf="activeView !== 'list'" (click)="onShowList()">
        <i class="icon-list"></i> Back to List
      </button>
    </div>
  </header>

  <div class="admin-content">
    <!-- List View -->
    <ng-container *ngIf="activeView === 'list'">
      <cbre-feature-flags-list
        [defaultFilterStatus]="config?.defaultFilterStatus || 'active'"
        (flagSelected)="onShowFlag($event)"
        (createFlag)="onCreateFlag()"
      >
      </cbre-feature-flags-list>
    </ng-container>

    <!-- Detail View -->
    <ng-container *ngIf="activeView === 'detail' && selectedFlagId">
      <cbre-feature-flag-detail
        [flagId]="selectedFlagId"
        [showEvaluation]="config?.showEvaluation"
        (editFlag)="onEditFlag($event)"
        (archiveFlag)="onFlagArchivedSuccess($event)"
      >
      </cbre-feature-flag-detail>
    </ng-container>

    <!-- Create View -->
    <ng-container *ngIf="activeView === 'create'">
      <cbre-feature-flag-form
        [advancedRuleBuilder]="config?.advancedRuleBuilder"
        (formSubmitted)="onFlagCreatedSuccess($event)"
        (formCancelled)="onShowList()"
      >
      </cbre-feature-flag-form>
    </ng-container>

    <!-- Edit View -->
    <ng-container *ngIf="activeView === 'edit' && selectedFlagId">
      <cbre-feature-flag-form
        [flagId]="selectedFlagId"
        [advancedRuleBuilder]="config?.advancedRuleBuilder"
        (formSubmitted)="onFlagUpdatedSuccess($event)"
        (formCancelled)="onShowFlag(selectedFlagId)"
      >
      </cbre-feature-flag-form>
    </ng-container>
  </div>
</div>
